import algosdk from 'algosdk'

export function toUintArray(input) {
    return Uint8Array.from(Array.from(input).map(letter => letter.charCodeAt(0)));
  }

export async function prepareTransactions(client, sender, creator, assetid, candidate,appid) {

    const params = await client.getTransactionParams().do();

    let txns = [
        algosdk.makeApplicationNoOpTxn(
            sender,
            params,
            parseInt(appid),
            [toUintArray('vote'), toUintArray(candidate)],
            [sender],
            undefined,
            [parseInt(assetid)],
        ),
        algosdk.makeAssetTransferTxnWithSuggestedParams(
            sender,
            creator,
            undefined,
            undefined,
            parseInt(1),
            undefined,
            parseInt(assetid),
            params)
    ]

    txns = algosdk.assignGroupID(txns)

    console.log(txns)

    return txns
}

export function signSend(wallet, net, sender="", creator="", assetid=0, candidate="", appid=0) {
    let algodClient = ""
    if (net === "TestNet") {
        algodClient = new algosdk.Algodv2("", 'https://api.testnet.algoexplorer.io', '');
    }
    else {
        algodClient = new algosdk.Algodv2("", 'https://algoexplorerapi.io', '');
    }
    let senderx = sender
    let creatorx = creator
    let assetidx = assetid
    let candidatex = candidate
    let appidx = appid

    prepareTransactions(algodClient, senderx, creatorx, assetidx, candidatex,appidx).then(txns => {
        let mySigned = [txns[0], txns[1]];
        wallet.signTransaction(mySigned.map(txn => txn.toByte())).then(data => {
            txns[0] = data[0].blob;
            txns[1] = data[1].blob
            console.log(txns)
            try {
                algodClient.sendRawTransaction(txns).do().then(response => {
                    window.reachLog += ("\nTXID: " + response.txId)
                })
            }
            catch (error) { console.log(error) }
        });
    })
}

export async function getAppCreator(net, appid) {
    let data = undefined
    let dataObj = undefined
    let id = undefined

    window.reachLog += "\nFetching creator address..."
  
    let url = ""
  
    if (net === "TestNet") {
      url = "https://algoindexer.testnet.algoexplorerapi.io"
    }
    else {
      url = "https://algoexplorerapi.io"
    }
  
    data = await fetch(url + '/v2/applications/' + parseInt(appid))
    dataObj = await data.json()
    id = await dataObj.application.params.creator
    window.reachLog += "\nCreator address: " + id
    return id
  }